// extracted by mini-css-extract-plugin
export default {"container":"call-to-action_container__KP+RL","content_wrapper":"call-to-action_content_wrapper__e4AiD"};